export default __webpack_public_path__ + "nda.523f5f10.png";